import { roleMixin } from './shared/helpers';
import store from '@/store';

// console.log('ths in nav file',store.state.salesCenter.lastOpenedTab);

export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
    },
    {
      name: 'Contact Center',
      url: store.state.contactCenter.lastOpenedTab || '/company',
      icon: 'fa fa-building',
    },
    {
      name: 'Sales Center',
      url: store.state.salesCenter.lastOpenedTab || '/requirements/',
      icon: 'fa fa-dollar',
    },
    ...(roleMixin.methods.checkClaim(roleMixin.data().CAN_ACCESS_VIEW_SHIPPING_CENTER) ? [{
      name: 'Shipping & Receiving',
      url: store.state.shippingReceiving.lastOpenedTab || '/shippingreceiving/pos',
      icon: 'fa fa-truck',
    }] : []),
    {
      name: 'Parts Center',
      url: store.state.partsCenter.lastOpenedTab || '/parts',
      icon: 'fa fa-cubes',
    },
    {
      name: 'Accounting Center',
      url: store.state.accountingCenter.lastOpenedTab || '/accounting',
      icon: 'fa fa-calculator',
    },
    {
      name: 'Reports',
      url: '/reports',
      icon: 'fa fa-flag',
    },  
    // {
    //   name: 'Administration',
    //   url: store.state.lookupMgmt.lastOpenedTab || '/admin/lookup-management',
    //   icon: 'fa fa-list-alt',
    // },    
    // {
    //   name: 'Administration',
    //   url: '/',
    //   icon: 'fa fa-user-circle-o',
    //   children: [
    //     {
    //       name: 'Warehouses',
    //       url: '/warehouses',
    //       icon: 'fa fa-home',
    //     },
    //     {
    //       name: 'Manufacturers',
    //       url: '/manufacturers',
    //       icon: 'fa fa-industry',
    //     },
    //     {
    //       name: 'Shipping',
    //       url: '/shipping',
    //       icon: 'fa fa-truck',
    //       children: [
    //         {
    //           name: 'Providers',
    //           url: '/shippingproviders',
    //           icon: 'fa fa-users',
    //         },
    //         {
    //           name: 'Methods',
    //           url: '/shippingmethods',
    //           icon: 'fa fa-tree',
    //         },
    //       ],
    //     },
    //     ...(roleMixin.methods.checkClaim(roleMixin.data().CAN_MANAGE_EMAIL_TEMPLATE) ? [{
    //       name: 'Email Template',
    //       url: '/admin/email-template',
    //       icon: 'fa fa-envelope',
    //     }] : []),
    //     {
    //       name: 'Lookup Management',
    //       url: '/lookups',
    //       icon: 'fa fa-list-alt',
    //       children: [
    //         ...(roleMixin.methods.checkClaim(roleMixin.data().CAN_ADD_LOOKUP) || roleMixin.methods.checkClaim(roleMixin.data().CAN_EDIT_LOOKUP) ? [{
    //           name: 'Lookup Tables',
    //           url: '/admin/lookup-management',
    //           icon: 'fa fa-table',
    //         }, {
    //           name: 'Billing Terms',
    //           url: '/admin/lookup/billing-terms',
    //           icon: 'fa fa-first-order',
    //         }, {
    //           name: 'NCM Codes',
    //           url: '/admin/lookup/ncm-codes',
    //           icon: 'fa fa-codepen',
    //         }, {
    //           name: 'Currency Types',
    //           url: '/admin/lookup/currency-types',
    //           icon: 'fa fa-dollar',
    //         }, {
    //           name: 'Account Type Attributes',
    //           url: '/admin/lookup/acct-type-attributes',
    //           icon: 'fa fa-address-card',
    //         }] : []),
    //       ],
    //     },
    //     {
    //       name: 'Questions',
    //       url: '/interviewquestions',
    //       icon: 'fa fa-question-circle',
    //     },
    //     {
    //       name: 'Settings',
    //       url: '/settings',
    //       icon: 'fa fa-cogs',
    //     },
    //     {
    //       name: 'User Management',
    //       url: store.state.userMgmt.lastOpenedTab || '/users',
    //       icon: 'fa fa-user',
    //     },
    //     {
    //       name: 'Quickbooks',
    //       url: '/quickbooks',
    //       icon: 'fa fa-address-card',
    //     },
    //   ],
    // },
  ],
};
